import { render, staticRenderFns } from "./SoilHumidityConfig.vue?vue&type=template&id=6edd31be&scoped=true"
import script from "./SoilHumidityConfig.vue?vue&type=script&lang=ts"
export * from "./SoilHumidityConfig.vue?vue&type=script&lang=ts"
import style0 from "./SoilHumidityConfig.vue?vue&type=style&index=0&id=6edd31be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edd31be",
  null
  
)

export default component.exports